import { CHECKBOX_KEYS, LIST_LOCATION_TYPE } from './constants'

export const getFilterLocationTypeOptions = () => {
  return Object.keys(LIST_LOCATION_TYPE).map((key) => {
    if (LIST_LOCATION_TYPE[key] === LIST_LOCATION_TYPE.HEADQUARTERS) {
      return {
        name: 'domesticSearch.' + key,
        value: LIST_LOCATION_TYPE[key],
        key: `${CHECKBOX_KEYS.LOCATION_TYPE}-${LIST_LOCATION_TYPE[key]}`,
        isShowInfo: true,
        tooltipInfo: 'domesticSearch.HEADQUARTER_TOOLTIP_INFO',
      }
    }

    return {
      name: 'domesticSearch.' + key,
      value: LIST_LOCATION_TYPE[key],
      key: `${CHECKBOX_KEYS.LOCATION_TYPE}-${LIST_LOCATION_TYPE[key]}`,
    }
  })
}
